import React from 'react';
import './App.css';
import MainComponent from './components/mainComponent';
import { Routes, Route } from 'react-router-dom';

const App: React.FunctionComponent = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

const Main = () => (
  <Routes>
    <Route path="*" element={<MainComponent />} />
  </Routes>
);

export default App;
